"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpaceContentStruct = void 0;
var SpaceContentStruct = (function () {
    function SpaceContentStruct(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
        this.name = data.name;
        this.description = typeof data.description !== 'undefined' ? data.description : undefined;
    }
    SpaceContentStruct.prototype.getPackageName = function () { return SpaceContentStruct.PackageName; };
    SpaceContentStruct.prototype.getClassName = function () { return SpaceContentStruct.ClassName; };
    SpaceContentStruct.prototype.getFullClassName = function () { return SpaceContentStruct.FullClassName; };
    Object.defineProperty(SpaceContentStruct.prototype, "name", {
        get: function () {
            return this._name;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                throw new Error('Field name is not optional');
            }
            if (typeof value !== 'string') {
                throw new Error('Field name expects type string, got ' + value);
            }
            this._name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SpaceContentStruct.prototype, "description", {
        get: function () {
            return this._description;
        },
        set: function (value) {
            if (typeof value === 'undefined' || value === null) {
                this._description = undefined;
                return;
            }
            if (typeof value !== 'string') {
                throw new Error('Field description expects type string, got ' + value);
            }
            this._description = value;
        },
        enumerable: false,
        configurable: true
    });
    SpaceContentStruct.prototype.serialize = function () {
        return {
            name: this.name,
            description: typeof this.description !== 'undefined' ? this.description : undefined
        };
    };
    SpaceContentStruct.register = function (className, ctor) {
        this._knownPolymorphic[className] = ctor;
    };
    SpaceContentStruct.create = function (data) {
        var polymorphicId = Object.keys(data)[0];
        var ctor = SpaceContentStruct._knownPolymorphic[polymorphicId];
        if (!ctor) {
            throw new Error('Unknown polymorphic type ' + polymorphicId + ' for SpaceContentStruct.Create');
        }
        return new ctor(data[polymorphicId]);
    };
    SpaceContentStruct.getRegisteredTypes = function () {
        return Object.keys(SpaceContentStruct._knownPolymorphic);
    };
    SpaceContentStruct.isRegisteredType = function (key) {
        return key in SpaceContentStruct._knownPolymorphic;
    };
    SpaceContentStruct.PackageName = 'net.playq.octopus2.apps.SpaceContent';
    SpaceContentStruct.ClassName = 'Struct';
    SpaceContentStruct.FullClassName = 'net.playq.octopus2.apps.SpaceContent.Struct';
    SpaceContentStruct._knownPolymorphic = {};
    return SpaceContentStruct;
}());
exports.SpaceContentStruct = SpaceContentStruct;
SpaceContentStruct.register(SpaceContentStruct.FullClassName, SpaceContentStruct);
var irt_1 = require("@playq/irt");
irt_1.Introspector.register('net.playq.octopus2.apps.SpaceContent', {
    full: 'net.playq.octopus2.apps.SpaceContent',
    short: 'SpaceContent',
    package: 'net.playq.octopus2.apps',
    type: irt_1.IntrospectorTypes.Mixin,
    ctor: function () { return new SpaceContentStruct(); },
    fields: [
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_1.IntrospectorTypes.Str }
        },
        {
            name: 'description',
            accessName: 'description',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Str } }
        }
    ],
    implementations: SpaceContentStruct.getRegisteredTypes
});
irt_1.Introspector.register(SpaceContentStruct.FullClassName, {
    full: SpaceContentStruct.FullClassName,
    short: SpaceContentStruct.ClassName,
    package: SpaceContentStruct.PackageName,
    type: irt_1.IntrospectorTypes.Data,
    ctor: function () { return new SpaceContentStruct(); },
    fields: [
        {
            name: 'name',
            accessName: 'name',
            type: { intro: irt_1.IntrospectorTypes.Str }
        },
        {
            name: 'description',
            accessName: 'description',
            type: { intro: irt_1.IntrospectorTypes.Opt, value: { intro: irt_1.IntrospectorTypes.Str } }
        }
    ]
});
//# sourceMappingURL=SpaceContent.js.map